import { Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BrandingService } from '../branding.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-contact-us-div',
  templateUrl: './app.contactus.html',
  styleUrls: ['./app.contactus.scss']
})

export class ContactUsComponent implements OnDestroy {
    @Input() titleText: string;
    @Input() mainText: string;
    @Input() contactNumber: string;
    @Input() productSelected: string;

    subscription: Subscription;
    constructor(private route: ActivatedRoute, private brandSvc: BrandingService) {
      this.subscription = brandSvc.brandInfo$.subscribe(
        brandInfo => {
          const queryParams = this.route.snapshot.queryParams;
          const reason = queryParams.reason;
          const productSelected = queryParams.productselected;

          this.productSelected = productSelected;
          this.contactNumber = this.getContactNumber(productSelected) || brandInfo.PhoneNumber;

          this.getReasonCodeText(reason, productSelected);
        });
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }

    getReasonCodeText(reason: string, productSelected: string) {
        if (reason === 'needs-verification') {
            this.titleText = 'We were unable to verify some of your info';
            this.mainText = 'Thank you for signing your application. Based on the information you submitted, ' +
                'we are not able to issue a policy online. Please call 1-' + this.contactNumber +
                ' to speak to one of our licensed life insurance agents to discuss next steps.';
        }
        if (reason === 'finish-your-quote') {
            this.titleText = this.getFinishYourQuoteTitleText(productSelected);
            this.mainText = this.getFinishYourQuoteMainText(productSelected);
        }
        if (reason === 'not-ready') {
            this.titleText = 'Not quite ready to sign your application?';
            this.mainText = 'If you have some additional questions or just want to speak with a live person, please call 1-'
             + this.contactNumber + ' to finish your application with one of our licensed life insurance agents.';
        }
        if (reason === 'session-ended') {
            this.titleText = 'Your session has ended';
            this.mainText = this.getSessionEndedMainText(productSelected);
        }
        if (reason === 'more-info') {
            this.titleText = this.getMoreInfoTitleText(productSelected);
            this.mainText = this.getMoreInfoMainText(productSelected);
        }
        if (reason === 'answers-you-need') {
            this.titleText = 'We are here to provide the answers you need';
            this.mainText = 'We understand you might have questions or would like to explore more life insurance options.' +
            'A licensed eFinancial agent will be reaching out to you soon. You can also call us at 1-' + this.contactNumber +
            ' to get answers right away.';
        }
    }

    getFinishYourQuoteTitleText(productSelected: string) {
      switch (productSelected) {
        case 'adb':
          return 'We were unable to complete your application';
        default:
          return 'Finish your quote on the phone';
      }
    }

    getFinishYourQuoteMainText(productSelected: string) {
      switch (productSelected) {
        case 'adb':
          return 'Thank you for your interest in our Accidental Death Insurance product. Based on the information you\'ve entered, ' +
            'we aren\'t able to complete your application. To explore other products visit us at' +
            '<a href=\'https://www.fidelitylife.com\'>www.fidelitylife.com</a> or you can talk to one ' +
            'of our licensed agents to discuss which products may be the best fit for you.';
        default:
          return 'Your situation is a bit unique. That\'s why it would be best to call 1-' + this.contactNumber +
          ' to speak to one of eFinancial\'s licensed life insurance agents. An agent can then help you find an option for you.';
      }
    }

    getMoreInfoTitleText(productSelected: string) {
      switch (productSelected) {
        case 'adb':
          return 'We were unable to complete your application';
        default:
          return 'We need a little more info';
      }
    }

    getMoreInfoMainText(productSelected: string) {
      switch (productSelected) {
        case 'adb':
          return 'Thank you for your interest in our Accidental Death Insurance product. Based on the information you\'ve entered, ' +
            'we aren\'t able to complete your application. To explore other products visit us at' +
            '<a href=\'https://www.fidelitylife.com\'>www.fidelitylife.com</a> or you can talk to one ' +
            'of our licensed agents to discuss which products may be the best fit for you.';
        default:
          return 'We need some additional information to continue your application. A licensed eFinancial life insurance agent will' +
           'be reaching out to you soon, or if you prefer, you can call us now to wrap everything up.';
      }
    }

    getSessionEndedMainText(productSelected: string) {
      switch (productSelected) {
        case 'adb':
          return 'Thank you for your interest in our Accidental Death Insurance product. Your session has timed out due to inactivity. ' +
            'To explore other products visit us at <a href=\'https://www.fidelitylife.com\'>www.fidelitylife.com</a>' +
             'or you can talk to one of our licensed agents to discuss which products may be the best fit for you.';
        default:
          return 'Your session has timed out due to inactivity. Please call 1-' + this.contactNumber +
            ' to speak with one of eFinancial\'s licensed life insurance agents to continue with your application.';
      }
    }

    getContactNumber(productSelected: string) {
      switch (productSelected) {
        case 'adb':
          return '833-460-1972';
      }
    }
}
